require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./sheshines-27-july-2023-gallery.json") })
        }
      }, "path---sheshines-27-july-2023-gallery");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---sheshines-27-july-2023-gallery!./.cache/json/sheshines-27-july-2023-gallery.json
// module id = 1205
// module chunks = 231608221292675